/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenWindow: BridgeCommands.Command<
    Types.Share.Osc.OpenWindowParameters,
    string
    > = {
    legacyCommand: 'QUERY_WIN_OPEN_OSC',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'OpenWindow',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CloseWindow: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_WIN_CLOSE_OSC',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'CloseWindow',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsDisplayInDesktopMode: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_OSC_DISPLAY_IS_DESKTOP_MODE',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'IsDisplayInDesktopMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const FullscreenState: BridgeCommands.Command<
    {},
    Types.Share.Osc.FullscreenStateReturn
    > = {
    legacyCommand: 'QUERY_FULLSCREEN_STATE',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'FullscreenState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetPainting: BridgeCommands.Command<
    Types.Share.Osc.SetPaintingParameters,
    any
    > = {
    legacyCommand: 'QUERY_OSC_SET_PAINTING',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'SetPainting',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCursorInfo: BridgeCommands.Command<
    Types.Share.Osc.SetCursorInfoParameters,
    any
    > = {
    legacyCommand: 'QUERY_OSC_SET_CURSOR_INFO',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'SetCursorInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DropUrl: BridgeCommands.Command<
    Types.Share.Osc.DropUrlParameters,
    any
    > = {
    legacyCommand: 'QUERY_OSC_DROP_URL',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'DropUrl',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GenerateKeyboardMessage: BridgeCommands.Command<
    Types.Share.Osc.GenerateKeyboardMessageParameters,
    any
    > = {
    legacyCommand: 'QUERY_WIN_KB_MESSAGE',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'GenerateKeyboardMessage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterCloseCommand: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_OSC_REGISTER_CLOSE_EVENT',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'RegisterCloseCommand',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDisplayRects: BridgeCommands.Command<
    Types.Share.Osc.SetDisplayRectsParameters,
    any
    > = {
    legacyCommand: 'QUERY_OSC_SET_DISPLAY_RECTS',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'SetDisplayRects',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterResizeEvent: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_OSC_REGISTER_RESIZE_EVENT',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'RegisterResizeEvent',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RelaunchNvAppClient: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_OSC_RELAUNCH_NVAPP',
    system: 'CrimsonNative',
    module: 'osc',
    method: 'RelaunchNvAppClient',
    persistent: false
};

export const Osc = {
OpenWindow,
CloseWindow,
IsDisplayInDesktopMode,
FullscreenState,
SetPainting,
SetCursorInfo,
DropUrl,
GenerateKeyboardMessage,
RegisterCloseCommand,
SetDisplayRects,
RegisterResizeEvent,
RelaunchNvAppClient
};
